<template>
  <div class="binding-follow-up-container">
    <el-card class="page-header-card">
      <div class="page-header">
        <div class="header-left">
          <h2>随访计划问卷绑定</h2>
          <el-tag type="primary">项目管理师工作台</el-tag>
        </div>
        <div class="header-right">
          <el-button type="primary" icon="el-icon-document-checked" @click="saveBinding">保存绑定</el-button>
        </div>
      </div>
    </el-card>

    <el-row :gutter="20">
      <!-- 左侧：随访计划选择 -->
      <el-col :span="14">
        <el-card class="follow-up-card">
          <div slot="header" class="card-header">
            <span>随访计划选择</span>
            <div class="filter-section">
              <el-input
                placeholder="搜索随访计划"
                v-model="searchKeyword"
                prefix-icon="el-icon-search"
                clearable
                style="width: 220px; margin-right: 10px"
              ></el-input>
              <el-select v-model="statusFilter" placeholder="状态筛选" style="width: 120px">
                <el-option label="全部状态" value="all"></el-option>
                <el-option label="待完成" value="upcoming"></el-option>
                <el-option label="已完成" value="completed"></el-option>
                <el-option label="已过期" value="missed"></el-option>
              </el-select>
            </div>
          </div>

          <el-table
            :data="filteredFollowUpPlans"
            style="width: 100%"
            @row-click="selectFollowUpPlan"
            highlight-current-row
            :row-class-name="followUpPlanRowClass"
          >
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column prop="id" label="计划ID" width="100"></el-table-column>
            <el-table-column prop="patientName" label="患者姓名" width="100"></el-table-column>
            <el-table-column prop="type" label="随访类型" width="120"></el-table-column>
            <el-table-column prop="date" label="随访时间" width="170"></el-table-column>
            <el-table-column prop="doctor" label="负责医生" width="100"></el-table-column>
            <el-table-column label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="getStatusType(scope.row.status)">{{ getStatusText(scope.row.status) }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="问卷绑定" width="100">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.questionnaireId" type="success">已绑定</el-tag>
                <el-tag v-else type="info">未绑定</el-tag>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-container">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next"
              :total="followUpPlans.length"
            >
            </el-pagination>
          </div>
        </el-card>
      </el-col>

      <!-- 右侧：问卷绑定设置 -->
      <el-col :span="10">
        <el-card class="binding-card" v-if="selectedPlan">
          <div slot="header" class="card-header">
            <span>问卷绑定设置</span>
          </div>
          
          <el-form ref="bindingForm" :model="bindingForm" label-width="120px" :rules="bindingRules">
            <el-form-item label="随访计划">
              <div class="selected-plan-info">
                <p><strong>患者：</strong>{{ selectedPlan.patientName }}</p>
                <p><strong>随访类型：</strong>{{ selectedPlan.type }}</p>
                <p><strong>随访时间：</strong>{{ selectedPlan.date }}</p>
                <p><strong>负责医生：</strong>{{ selectedPlan.doctor }}</p>
              </div>
            </el-form-item>
            
            <el-divider content-position="center">问卷设置</el-divider>
            
            <el-form-item label="选择问卷模板" prop="questionnaireId">
              <el-select 
                v-model="bindingForm.questionnaireId" 
                placeholder="请选择问卷模板"
                style="width: 100%"
                filterable
              >
                <el-option
                  v-for="item in questionnaires"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                  <span style="float: left">{{ item.title }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ item.type === 'satisfaction' ? '满意度' : item.type === 'followup' ? '随访' : '评估' }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item label="发送时间" prop="sendTime">
              <el-radio-group v-model="bindingForm.sendTimeType">
                <el-radio label="before">随访前</el-radio>
                <el-radio label="after">随访后</el-radio>
                <el-radio label="custom">自定义</el-radio>
              </el-radio-group>
              
              <div class="time-setting" v-if="bindingForm.sendTimeType === 'before' || bindingForm.sendTimeType === 'after'">
                <el-input-number 
                  v-model="bindingForm.timeOffset" 
                  :min="1" 
                  :max="30"
                  style="width: 120px"
                ></el-input-number>
                <el-select v-model="bindingForm.timeUnit" style="width: 120px; margin-left: 10px">
                  <el-option label="小时" value="hour"></el-option>
                  <el-option label="天" value="day"></el-option>
                </el-select>
              </div>
              
              <el-date-picker
                v-if="bindingForm.sendTimeType === 'custom'"
                v-model="bindingForm.customTime"
                type="datetime"
                placeholder="选择自定义发送时间"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
            
            <el-form-item label="提醒方式" prop="remindMethod">
              <el-checkbox-group v-model="bindingForm.remindMethod">
                <el-checkbox label="sms">短信</el-checkbox>
                <el-checkbox label="app">APP推送</el-checkbox>
                <el-checkbox label="wechat">微信</el-checkbox>
                <el-checkbox label="call">电话</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            
            <el-form-item label="提醒次数" prop="remindTimes">
              <el-input-number 
                v-model="bindingForm.remindTimes" 
                :min="1" 
                :max="5"
                style="width: 120px"
              ></el-input-number>
              <span class="form-item-hint">（设置未完成问卷的最大提醒次数）</span>
            </el-form-item>
            
            <el-form-item label="提醒间隔" prop="remindInterval">
              <el-input-number 
                v-model="bindingForm.remindInterval" 
                :min="1" 
                :max="72"
                style="width: 120px"
              ></el-input-number>
              <span class="form-item-hint">小时（每次提醒的间隔时间）</span>
            </el-form-item>
            
            <el-form-item label="截止日期" prop="deadline">
              <el-date-picker
                v-model="bindingForm.deadline"
                type="datetime"
                placeholder="选择问卷填写截止时间"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
            
            <el-form-item label="备注说明">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入备注说明"
                v-model="bindingForm.notes"
              ></el-input>
            </el-form-item>

            <el-form-item label="回复通知">
              <el-switch
                v-model="bindingForm.notifyOnSubmit"
                active-text="患者提交问卷后通知医生"
              ></el-switch>
            </el-form-item>
          </el-form>
        </el-card>
        
        <el-card v-else class="empty-binding-card">
          <div class="empty-state">
            <i class="el-icon-document"></i>
            <p>请先从左侧选择一个随访计划</p>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 预览问卷对话框 -->
    <el-dialog
      title="问卷预览"
      :visible.sync="previewDialogVisible"
      width="70%"
      :before-close="handlePreviewClose"
    >
      <div v-if="selectedQuestionnaire" class="questionnaire-preview">
        <h1>{{ selectedQuestionnaire.title }}</h1>
        <p class="questionnaire-desc">{{ selectedQuestionnaire.description }}</p>
        
        <div v-for="(question, index) in selectedQuestionnaire.questions" :key="index" class="preview-question">
          <div class="question-title">
            {{ index + 1 }}. {{ question.title }}
            <span v-if="question.required" class="required-mark">*</span>
          </div>
          <div class="question-description" v-if="question.description">
            {{ question.description }}
          </div>
          
          <!-- 单选题 -->
          <el-radio-group v-if="question.type === 'radio'" disabled>
            <div v-for="(option, optIndex) in question.options" :key="optIndex" class="option-item">
              <el-radio :label="optIndex" disabled>{{ option }}</el-radio>
            </div>
            <div v-if="question.hasOther" class="option-item">
              <el-radio :label="-1" disabled>{{ question.otherText }}</el-radio>
            </div>
          </el-radio-group>
          
          <!-- 多选题 -->
          <el-checkbox-group v-else-if="question.type === 'checkbox'" disabled>
            <div v-for="(option, optIndex) in question.options" :key="optIndex" class="option-item">
              <el-checkbox :label="optIndex" disabled>{{ option }}</el-checkbox>
            </div>
            <div v-if="question.hasOther" class="option-item">
              <el-checkbox :label="-1" disabled>{{ question.otherText }}</el-checkbox>
            </div>
          </el-checkbox-group>
          
          <!-- 文本题 -->
          <div v-else-if="question.type === 'text'">
            <el-input 
              :type="question.inputType === 'singleLine' ? 'text' : 'textarea'"
              :rows="question.rows"
              :placeholder="question.placeholder"
              disabled
            ></el-input>
          </div>
          
          <!-- 评分题 -->
          <div v-else-if="question.type === 'rate'">
            <el-rate 
              :max="question.maxRate"
              disabled
              show-text
              :texts="['极差', '较差', '一般', '较好', '极好']"
            ></el-rate>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="previewDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="selectCurrentQuestionnaire">选择此问卷</el-button>
      </span>
    </el-dialog>

    <!-- 绑定成功提示 -->
    <el-dialog
      title="绑定成功"
      :visible.sync="successDialogVisible"
      width="30%"
      :show-close="false"
      center
    >
      <div class="success-message">
        <i class="el-icon-success"></i>
        <p>问卷已成功绑定到随访计划</p>
        <div class="success-detail">
          <p><strong>患者：</strong>{{ selectedPlan ? selectedPlan.patientName : '' }}</p>
          <p><strong>问卷：</strong>{{ bindingForm.questionnaireId ? getQuestionnaireName(bindingForm.questionnaireId) : '' }}</p>
          <p><strong>发送时间：</strong>{{ getFormattedSendTime() }}</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="successDialogVisible = false">确定</el-button>
        <el-button @click="resetBinding">继续绑定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "BindingFollowUp",
  data() {
    return {
      // 分页相关
      currentPage: 1,
      pageSize: 5,
      
      // 搜索筛选
      searchKeyword: "",
      statusFilter: "upcoming",
      
      // 选择的随访计划
      selectedPlan: null,
      
      // 绑定表单
      bindingForm: {
        questionnaireId: "",
        sendTimeType: "after",
        timeOffset: 1,
        timeUnit: "day",
        customTime: null,
        remindMethod: ["app", "wechat"],
        remindTimes: 3,
        remindInterval: 24,
        deadline: null,
        notes: "",
        notifyOnSubmit: true
      },
      
      // 表单验证规则
      bindingRules: {
        questionnaireId: [
          { required: true, message: "请选择问卷模板", trigger: "change" }
        ],
        remindMethod: [
          { type: "array", required: true, message: "请至少选择一种提醒方式", trigger: "change" }
        ],
        deadline: [
          { required: true, message: "请设置问卷填写截止时间", trigger: "change" }
        ]
      },
      
      // 问卷预览
      previewDialogVisible: false,
      selectedQuestionnaire: null,
      
      // 成功提示
      successDialogVisible: false,
      
      // 模拟数据 - 随访计划列表
      followUpPlans: [
        {
          id: "FP10001",
          patientName: "许昊然",
          genderAge: "男/45岁",
          type: "术后随访",
          date: "2023-05-15 10:30",
          doctor: "王医生",
          department: "肿瘤科",
          status: "upcoming",
          medicalRecordNo: "MR123456",
          questionnaireId: "",
          notes: "首次术后随访，关注伤口恢复情况"
        },
        {
          id: "FP10002",
          patientName: "苏雅婷",
          genderAge: "女/32岁",
          type: "药物评估",
          date: "2023-05-17 14:00",
          doctor: "赵医生",
          department: "内分泌科",
          status: "upcoming",
          medicalRecordNo: "MR234567",
          questionnaireId: "QN100456",
          notes: "评估药物副作用"
        },
        {
          id: "FP10003",
          patientName: "林书辰",
          genderAge: "男/58岁",
          type: "定期随访",
          date: "2023-05-10 09:00",
          doctor: "钱医生",
          department: "心内科",
          status: "completed",
          medicalRecordNo: "MR345678",
          questionnaireId: "",
          notes: "冠心病定期随访"
        },
        {
          id: "FP10004",
          patientName: "程若曦",
          genderAge: "女/65岁",
          type: "康复评估",
          date: "2023-05-08 11:30",
          doctor: "孙医生",
          department: "康复科",
          status: "completed",
          medicalRecordNo: "MR456789",
          questionnaireId: "QN100789",
          notes: "脑卒中后康复评估"
        },
        {
          id: "FP10005",
          patientName: "郭子轩",
          genderAge: "男/41岁",
          type: "症状监测",
          date: "2023-05-20 16:00",
          doctor: "周医生",
          department: "消化内科",
          status: "upcoming",
          medicalRecordNo: "MR567890",
          questionnaireId: "",
          notes: "消化道症状监测"
        },
        {
          id: "FP10006",
          patientName: "韩宇航",
          genderAge: "女/37岁",
          type: "术后随访",
          date: "2023-05-01 10:00",
          doctor: "吴医生",
          department: "普外科",
          status: "missed",
          medicalRecordNo: "MR678901",
          questionnaireId: "",
          notes: "胆囊切除术后随访"
        },
        {
          id: "FP10007",
          patientName: "江语涵",
          genderAge: "男/52岁",
          type: "治疗效果评估",
          date: "2023-05-18 13:30",
          doctor: "郑医生",
          department: "肿瘤科",
          status: "upcoming",
          medicalRecordNo: "MR789012",
          questionnaireId: "",
          notes: "放疗效果评估"
        }
      ],
      
      // 模拟数据 - 问卷模板列表
      questionnaires: [
        {
          id: "QN100123",
          title: "术后恢复情况问卷",
          type: "followup",
          description: "用于评估患者术后恢复情况与生活质量",
          questions: [
            {
              id: "Q1",
              type: "radio",
              title: "您的伤口恢复情况如何？",
              required: true,
              options: ["非常好", "良好", "一般", "较差", "很差"],
              hasOther: false
            },
            {
              id: "Q2",
              type: "checkbox",
              title: "您目前是否存在以下症状？（多选）",
              required: true,
              options: ["疼痛", "红肿", "渗液", "发热", "瘙痒"],
              hasOther: true,
              otherText: "其他症状"
            },
            {
              id: "Q3",
              type: "text",
              title: "请描述您的恢复过程中遇到的主要困难",
              required: false,
              inputType: "multiLine",
              rows: 3,
              placeholder: "请详细描述您遇到的问题..."
            }
          ]
        },
        {
          id: "QN100456",
          title: "药物治疗评估问卷",
          type: "assessment",
          description: "用于评估药物治疗效果和不良反应",
          questions: [
            {
              id: "Q1",
              type: "radio",
              title: "您认为目前的药物治疗效果如何？",
              required: true,
              options: ["非常有效", "有效", "一般", "效果不明显", "无效"],
              hasOther: false
            },
            {
              id: "Q2",
              type: "checkbox",
              title: "您是否出现以下不良反应？（多选）",
              required: true,
              options: ["头晕", "恶心", "皮疹", "腹泻", "乏力", "失眠"],
              hasOther: true,
              otherText: "其他不良反应"
            }
          ]
        },
        {
          id: "QN100789",
          title: "康复训练效果评估",
          type: "assessment",
          description: "用于评估康复训练的效果与患者满意度",
          questions: [
            {
              id: "Q1",
              type: "rate",
              title: "请评价康复训练的整体效果",
              required: true,
              maxRate: 5
            },
            {
              id: "Q2",
              type: "radio",
              title: "康复训练后，您的日常活动能力是否有所改善？",
              required: true,
              options: ["显著改善", "有所改善", "无明显变化", "有所下降"],
              hasOther: false
            }
          ]
        },
        {
          id: "QN100345",
          title: "医疗服务满意度调查",
          type: "satisfaction",
          description: "了解患者对医疗服务的满意程度",
          questions: [
            {
              id: "Q1",
              type: "rate",
              title: "请评价医生的服务态度",
              required: true,
              maxRate: 5
            },
            {
              id: "Q2",
              type: "rate",
              title: "请评价医院的环境与设施",
              required: true,
              maxRate: 5
            },
            {
              id: "Q3",
              type: "text",
              title: "您对我们的医疗服务有什么建议？",
              required: false,
              inputType: "multiLine",
              rows: 3,
              placeholder: "请输入您的宝贵建议..."
            }
          ]
        }
      ]
    };
  },
  
  computed: {
    // 筛选后的随访计划
    filteredFollowUpPlans() {
      return this.followUpPlans
        .filter(plan => {
          // 关键字搜索
          const searchMatch = 
            !this.searchKeyword || 
            plan.id.toLowerCase().includes(this.searchKeyword.toLowerCase()) ||
            plan.patientName.includes(this.searchKeyword) ||
            plan.type.includes(this.searchKeyword) ||
            plan.doctor.includes(this.searchKeyword);
            
          // 状态筛选
          const statusMatch = this.statusFilter === 'all' || plan.status === this.statusFilter;
            
          return searchMatch && statusMatch;
        })
        .slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    }
  },
  
  created() {
    // 初始化截止日期为7天后
    const deadline = new Date();
    deadline.setDate(deadline.getDate() + 7);
    this.bindingForm.deadline = deadline;
  },
  
  methods: {
    // 分页处理
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    
    // 选择随访计划
    selectFollowUpPlan(plan) {
      this.selectedPlan = plan;
      
      // 如果已经绑定问卷，加载已有设置
      if (plan.questionnaireId) {
        this.bindingForm.questionnaireId = plan.questionnaireId;
        // 这里可以加载其他已有的绑定设置
      } else {
        // 重置绑定表单
        this.resetBindingForm();
      }
    },
    
    // 获取状态显示文本
    getStatusText(status) {
      const statusMap = {
        'upcoming': '待完成',
        'completed': '已完成',
        'missed': '已过期'
      };
      return statusMap[status] || status;
    },
    
    // 获取状态类型（用于标签颜色）
    getStatusType(status) {
      const typeMap = {
        'upcoming': 'primary',
        'completed': 'success',
        'missed': 'danger'
      };
      return typeMap[status] || 'info';
    },
    
    // 行样式
    followUpPlanRowClass({ row }) {
      return row.questionnaireId ? 'has-questionnaire-row' : '';
    },
    
    // 打开问卷预览
    previewQuestionnaire(questionnaireId) {
      const questionnaire = this.questionnaires.find(q => q.id === questionnaireId);
      if (questionnaire) {
        this.selectedQuestionnaire = questionnaire;
        this.previewDialogVisible = true;
      } else {
        this.$message.error('未找到问卷模板信息');
      }
    },
    
    // 关闭问卷预览
    handlePreviewClose() {
      this.previewDialogVisible = false;
      this.selectedQuestionnaire = null;
    },
    
    // 选择当前预览的问卷
    selectCurrentQuestionnaire() {
      if (this.selectedQuestionnaire) {
        this.bindingForm.questionnaireId = this.selectedQuestionnaire.id;
        this.previewDialogVisible = false;
      }
    },
    
    // 获取问卷名称
    getQuestionnaireName(id) {
      const questionnaire = this.questionnaires.find(q => q.id === id);
      return questionnaire ? questionnaire.title : id;
    },
    
    // 获取格式化的发送时间描述
    getFormattedSendTime() {
      if (this.bindingForm.sendTimeType === 'before') {
        return `随访前 ${this.bindingForm.timeOffset} ${this.bindingForm.timeUnit === 'hour' ? '小时' : '天'}`;
      } else if (this.bindingForm.sendTimeType === 'after') {
        return `随访后 ${this.bindingForm.timeOffset} ${this.bindingForm.timeUnit === 'hour' ? '小时' : '天'}`;
      } else if (this.bindingForm.sendTimeType === 'custom' && this.bindingForm.customTime) {
        return this.formatDateTime(this.bindingForm.customTime);
      }
      return '未设置';
    },
    
    // 格式化日期时间
    formatDateTime(date) {
      if (!date) return '';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hour = String(d.getHours()).padStart(2, '0');
      const minute = String(d.getMinutes()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hour}:${minute}`;
    },
    
    // 重置绑定表单
    resetBindingForm() {
      this.bindingForm = {
        questionnaireId: "",
        sendTimeType: "after",
        timeOffset: 1,
        timeUnit: "day",
        customTime: null,
        remindMethod: ["app", "wechat"],
        remindTimes: 3,
        remindInterval: 24,
        deadline: (() => {
          const deadline = new Date();
          deadline.setDate(deadline.getDate() + 7);
          return deadline;
        })(),
        notes: "",
        notifyOnSubmit: true
      };
    },
    
    // 保存绑定
    saveBinding() {
      if (!this.selectedPlan) {
        this.$message.warning('请先选择一个随访计划');
        return;
      }
      
      this.$refs.bindingForm.validate(valid => {
        if (valid) {
          // 模拟保存操作
          const loading = this.$loading({
            lock: true,
            text: '正在保存绑定关系...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          
          setTimeout(() => {
            loading.close();
            
            // 更新随访计划的问卷绑定状态
            const index = this.followUpPlans.findIndex(plan => plan.id === this.selectedPlan.id);
            if (index !== -1) {
              this.followUpPlans[index].questionnaireId = this.bindingForm.questionnaireId;
              this.selectedPlan = this.followUpPlans[index];
            }
            
            // 显示成功提示
            this.successDialogVisible = true;
            
            console.log('绑定信息:', {
              planId: this.selectedPlan.id,
              patientName: this.selectedPlan.patientName,
              questionnaireId: this.bindingForm.questionnaireId,
              questionnaireName: this.getQuestionnaireName(this.bindingForm.questionnaireId),
              sendTimeType: this.bindingForm.sendTimeType,
              timeOffset: this.bindingForm.timeOffset,
              timeUnit: this.bindingForm.timeUnit,
              customTime: this.bindingForm.customTime,
              remindMethod: this.bindingForm.remindMethod,
              remindTimes: this.bindingForm.remindTimes,
              remindInterval: this.bindingForm.remindInterval,
              deadline: this.bindingForm.deadline,
              notes: this.bindingForm.notes,
              notifyOnSubmit: this.bindingForm.notifyOnSubmit
            });
          }, 1000);
        } else {
          this.$message.error('请完善绑定设置信息');
          return false;
        }
      });
    },
    
    // 重置绑定（用于成功对话框）
    resetBinding() {
      this.selectedPlan = null;
      this.resetBindingForm();
      this.successDialogVisible = false;
    }
  }
};
</script>

<style scoped>
.binding-follow-up-container {
  padding: 20px;
}

.page-header-card {
  margin-bottom: 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-left h2 {
  margin-right: 10px;
  margin-bottom: 0;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.follow-up-card {
  margin-bottom: 20px;
}

.filter-section {
  display: flex;
  align-items: center;
}

.pagination-container {
  margin-top: 20px;
  text-align: center;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #909399;
}

.empty-state i {
  font-size: 48px;
  margin-bottom: 20px;
}

.selected-plan-info {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 15px;
  background-color: #f5f7fa;
}

.selected-plan-info p {
  margin: 5px 0;
}

.time-setting {
  margin-top: 15px;
}

.form-item-hint {
  margin-left: 10px;
  color: #909399;
  font-size: 13px;
}

.success-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
}

.success-message i {
  font-size: 48px;
  color: #67c23a;
  margin-bottom: 20px;
}

.success-detail {
  margin-top: 15px;
  padding: 15px;
  width: 100%;
  border: 1px solid #e1f3d8;
  border-radius: 4px;
  background-color: #f0f9eb;
}

.success-detail p {
  margin: 8px 0;
}

.has-questionnaire-row {
  background-color: #f0f9eb;
}

.required-mark {
  color: #f56c6c;
  margin-left: 4px;
}

.questionnaire-preview {
  padding: 0 20px;
}

.questionnaire-desc {
  color: #606266;
  margin-bottom: 20px;
}

.preview-question {
  margin-bottom: 25px;
  padding: 15px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.question-title {
  font-weight: bold;
  margin-bottom: 10px;
}

.question-description {
  color: #909399;
  margin-bottom: 15px;
  font-size: 14px;
}

.option-item {
  margin-bottom: 10px;
}

/* 自定义组件的高度，以适应更多内容 */
.empty-binding-card {
  min-height: 400px;
}

.binding-card {
  min-height: 400px;
}

/* 模态框警告样式 */
.warning {
  color: #e6a23c;
  border-left: 3px solid #e6a23c;
  padding-left: 10px;
  margin: 15px 0;
}

.confirm-buttons {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 20px;
}

.confirm-yes {
  padding: 8px 20px;
  background-color: #f56c6c;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.confirm-no {
  padding: 8px 20px;
  background-color: #909399;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>